<template>
  <!-- 电商类申报 -->
  <ModuleSection :title="$route.meta.title">
    <!-- 表单 -->
    <el-form
      ref="submitForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      label-width="180px">
      <!-- 详情公共回显信息 -->
      <div
        v-if="type === 'Detail'"
        class="detail-area">
        <el-form-item
          :label="$t('申报时间')"
          class="detail-item">
          {{ declareDetail.declaredTime }}
        </el-form-item>
        <el-form-item
          :label="$t('审核时间')"
          class="detail-item">
          {{ declareDetail.lastCheckTime }}
        </el-form-item>
        <el-form-item
          :label="$t('申报状态')"
          class="detail-item">
          <p
            :style="declareDetail.declareStatus === 'REJECT' ? 'color: #F34359;' : ''">
            {{ $t(declareStatusMap[declareDetail.declareStatus]) }}
          </p>
        </el-form-item>
        <!-- 拒绝或者已退汇状态下显示 -->
        <el-form-item
          v-if="declareDetail.declareStatus === 'REJECT' || declareDetail.declareStatus === 'REFUND'"
          :label="$t('拒绝原因')"
          class="detail-item">
          {{ $t(declareDetail.refuseReason) }}
        </el-form-item>
      </div>
      <!-- 账号在新增 详情或者修改页面均不可改 -->
      <el-form-item
        :label="$t('汇入汇款账号')"
        prop="account"
      >
        <el-select
          v-model="formData.account"
          :placeholder="$t('请选择')"
          :disabled="true"
          class="form-item"
          @change="handleAccountSelect">
          <el-option
            v-for="(item, index) in msbdAccountMap"
            :key="index"
            :label="item | translateFilter"
            :value="index" />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('汇款金额')"
        prop="amount"
      >
        <el-input
          v-model="formData.amount"
          :placeholder="$t('请输入汇款金额')"
          :disabled="true"
          type="number"
          class="form-item"
          @blur="handleAmountBlur"/>
        <span
          style="margin-left: 20px;font-size: 14px;color: #5A607F;">
          {{ $t(formData.currency) }}
        </span>
      </el-form-item>
      <el-form-item
        :label="$t('汇款人姓名')"
        prop="payName"
      >
        <div style="display: flex; align-items: center;">
          <el-input
            v-model="formData.payName"
            :placeholder="$t('请输入汇款人姓名')"
            :disabled="true"
            type="text"
            class="form-item"/>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('电商平台')"
        prop="eCommerce"
      >
        <el-select
          v-model="formData.eCommerce"
          :placeholder="$t('请选择')"
          :disabled="type === 'Detail'"
          class="form-item">
          <el-option
            v-for="item in eCommerceList"
            :key="item"
            :label="$t(item)"
            :value="item" />
        </el-select>
      </el-form-item>
      <!-- 上传组件 -->
      <el-form-item
        :label="$t('资金证明材料')"
        prop="fileList"
      >
        <UploadFile
          :file-list="formData.fileList"
          :disabled="type === 'Detail'"
          class="form-item">
        </UploadFile>
      </el-form-item>
      <!-- tip -->
      <el-form-item v-if="type !== 'Detail'">
        <div style="display: flex; align-items: flex-start; width: 500px;">
          <span style="color:#F34359; line-height: 20px; margin-right: 9px;">*</span>
          <div>
            <p class="tip-item">
              {{ $t('上传能证明该笔资金汇款用途/目的的文件，包括但不限于发票、合同或者协议、报关单、提货单') }}
            </p>
            <p class="tip-item">
              {{ $t('单个xls，pdf、jpg、jpeg、png等文件不超过10M，最多上传10个文件') }}
            </p>
            <p class="tip-item">
              {{ $t('明确汇款公司有利于提高收款审核效率') }}
            </p>
          </div>
        </div>
      </el-form-item>
      <!-- 按钮 -->
      <el-form-item>
        <div>
          <el-button
            v-if="type === 'Add'"
            type="primary"
            class="btn"
            @click="handleGoDeclare">
            {{ $t('去申报') }}
          </el-button>
          <el-button
            v-if="type === 'Detail' && declareDetail.declareStatus === 'REJECT'"
            type="primary"
            class="btn"
            @click="handleReSubmit">
            {{ $t('重新提交') }}
          </el-button>
          <el-button
            v-if="type === 'Update' && declareDetail.declareStatus === 'REJECT'"
            type="primary"
            class="btn"
            @click="handleUpdateDeclare">
            {{ $t('重新提交') }}
          </el-button>
          <el-button class="btn" @click="$router.go(-1)">{{ $t('返回') }}</el-button>
        </div>
      </el-form-item>
    </el-form>
  </ModuleSection>
</template>

<script>
import { declareStatusMap } from './constants'
import declareApi from './api'
export default {
  // name: 'DeclareInnerMsbdAddCache',
  data () {
    const msbdAccountMap = this.$_params.getSessionAccountSelect_obj_only_d('ALL', true, 0)
    return {
      declareStatusMap,
      msbdAccountMap,
      eCommerceList: [],
      /* 路由信息 */
      // Add Detail Update
      type: '',
      accNo: '',
      reportId: '',
      /* 新增 */
      formData: {
        account: '',
        amount: '',
        payName: '',
        eCommerce: '',
        fileList: []
      },
      /* 回显 */
      declareDetail: {}
    }
  },
  computed: {
    rules () {
      return {
        account: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        amount: [
          { required: true, trigger: 'blur', validator: this.amountValidator }
        ],
        payName: [
          { required: true, message: this.$t('请输入'), trigger: 'blur' }
        ],
        eCommerce: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        fileList: [
          { required: true, message: this.$t('请上传'), trigger: 'change' }
        ]
      }
    },
    amountValidator () {
      return (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('请输入')))
          return
        }
        const { currency } = this.formData
        if ((currency === 'JPY' || currency === 'KRW') && (!/.00$/.test(value))) {
          callback(new Error(this.$t('日元和韩元账户汇款金额只能为整数，请重新输入！')))
          return
        }
        callback()
      }
    }
  },
  created () {
    this.getShopPlatforms()
    // 页面激活的时候 获取路由数据
    const { type, accNo, reportId } = this.$route.query
    this.type = type
    this.accNo = accNo
    this.reportId = reportId
    // 新增 详情 重新提交
    declareApi.getMsbdDeclareDetail({
      receiptInputId: reportId
    }).then(res => {
      if (res) {
        this.declareDetail = res
        const { accountNo, currency, amount, remitName, declarePlatform, declareFileList } = res
        // 账号
        for (const key in this.msbdAccountMap) {
          if (key.indexOf(accountNo) > -1) {
            this.formData.account = key
          }
        }
        // 币种
        this.formData.currency = currency
        // 汇款金额
        this.formData.amount = Number(amount).toFixed(2)
        // 汇款人姓名
        this.formData.payName = remitName
        // 电商平台
        this.formData.eCommerce = declarePlatform
        // 资金证明材料
        this.formData.fileList = declareFileList || []
      }
    }).catch(err => {
      console.error(err)
    })
  },
  methods: {
    // 账号
    handleAccountSelect (val) {
      const list = val.split('|')
      this.formData.currency = list[1]
    },
    // 汇款金额
    handleAmountBlur (e) {
      const val = e.target.value
      this.formData.amount = Number(val).toFixed(2)
    },
    // 电商平台
    getShopPlatforms () {
      return declareApi.getShopPlatforms().then(res => {
        if (res) {
          this.eCommerceList = res.list
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 提交申报
    handleGoDeclare (flag) {
      this.$refs.submitForm.validate(valid => {
        if (valid) {
          const { reportId: id } = this
          const { eCommerce: platform, fileList: declareFileList } = this.formData
          this.$tconfirm('确定提交该汇入汇款申报？').then(_ => {
            declareApi.submitMsbdDeclare({
              id,
              platform,
              declareFileList
            }).then(res => {
              if (res) {
                const msg = flag === 'update' ? '重新提交成功' : '提交成功'
                this.$success(msg)
                this.$router.go(-1)
              }
            }).catch(err => {
              console.error(err)
            })
          }).catch(_ => {})
        }
      })
    },
    // 审核拒绝后，重新提交，跳转Update页
    handleReSubmit () {
      const { accNo, reportId } = this
      this.$router.replace({
        name: 'DeclareInnerMsbdUpdate',
        query: {
          type: 'Update',
          accNo,
          reportId
        }
      })
    },
    // Update页 重新申报
    handleUpdateDeclare () {
      this.handleGoDeclare('update')
    }
  }
}
</script>

<style scoped lang="less">
.form-item {
  width: 500px;
}
.tip-item {
  font-size: 12px;
  font-weight: 300;
  color: #A1A7C4;
  line-height: 17px;
}
.btn {
  min-width: 140px;
  height: 40px;
}
.detail-area {
  margin-bottom: 40px;
  border-bottom: 1px solid #E6E9F4;
  .detail-item {
    height: 14px;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 40px;
    }
    /deep/.el-form-item__label {
      line-height: 14px;
    }
    /deep/.el-form-item__content {
      line-height: 14px;
    }
  }
}
</style>
